import React, { ReactElement } from 'react'
import { Box, Typography } from '@mui/material'
import AdminSchedulerView from './admin-scheduler-view'

export default function SchedulingTab(): ReactElement {
  return (
    <Box>
      <Typography variant="h5" component="h2" sx={{ mb: 1 }}>
        Instructor Scheduling — Admin View
      </Typography>
      <Typography color="text.secondary" variant="body2" sx={{ mb: 3 }}>
        Schedule sessions for any instructor. Use the resource filter in the
        calendar to focus on a specific instructor.
      </Typography>
      <AdminSchedulerView />
    </Box>
  )
}
